<div class="container h-100">
  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="card w-100 h-100">
        <div class="card-body p-0 h-100">
          <div [class.out]="loading" class="shrink-top-animated h-100">
            <div class="text-center my-5">
              <fa-icon
                [icon]="spinnerIcon"
                animation="spin-pulse"
                class=""
                size="3x"
              ></fa-icon>
              <div class="">Die Ansicht wird geladen ...</div>
            </div>
          </div>
          <div
            [class.out]="!loading"
            class="shrink-top-animated p-0 p-md-3 h-100"
          >
            <san-info *ngIf="!token"></san-info>
            <ng-container *ngIf="token">
              <san-stepper
                #stepperComponent
                [hideBottomButtons]="true"
                [showSteps]="false"
                class="mh-100"
              >
                <san-step #stepPin>
                  <san-pin
                    (anmeldenClicked)="sendCredentials($event)"
                    [sending]="sending"
                    [token]="token"
                    [wrongCredentials]="wrongCredentials"
                  ></san-pin>
                </san-step>
                <san-step #stepZustimmung>
                  <san-zustimmung
                    (bestaetigenClicked)="einschreiben($event)"
                    [pin]="pin"
                    [sending]="sending"
                    [state]="state"
                    [token]="token"
                  ></san-zustimmung>
                </san-step>
                <san-step #stepZustimmungBestaetigung>
                  <san-zustimmung-bestaetigung
                    (abmeldenClicked)="abmelden()"
                    (downloadTneClicked)="downloadTNE()"
                    (widerrufClicked)="widerruf()"
                    [pin]="pin"
                    [state]="state"
                    [teilnahmeerklaerung]="state?.teilnahmeerklaerung_abrufbar"
                    [token]="token"
                    [widerruf]="showLinkToWiderruf"
                  ></san-zustimmung-bestaetigung>
                </san-step>
                <san-step #stepWiderruf>
                  <san-widerruf
                    (abmeldenClicked)="abmelden()"
                    (bestaetigenClicked)="widerrufBestaetigen()"
                    (downloadTneClicked)="downloadTNE()"
                    [credentials]="{ link_token: token, pin }"
                    [state]="state"
                    [teilnahmeerklaerung]="state?.teilnahmeerklaerung_abrufbar"
                  ></san-widerruf>
                </san-step>
                <san-step #stepWiderrufBestaetigung>
                  <san-widerruf-bestaetigung
                    (abmeldenClicked)="abmelden()"
                    (downloadTneClicked)="downloadTNE()"
                    [state]="state"
                    [teilnahmeerklaerung]="state?.teilnahmeerklaerung_abrufbar"
                  ></san-widerruf-bestaetigung>
                </san-step>
                <san-step #stepUngueltigeEinschreibung>
                  <div class="text-center my-5">
                    <fa-icon
                      [icon]="iconExclamation"
                      class="text-danger"
                      size="3x"
                    ></fa-icon>
                    <div class="">
                      Ihre Zugangsdaten sind korrekt. Jedoch wurde die
                      Einschreibung deaktiviert.
                    </div>
                  </div>
                </san-step>
              </san-stepper>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
